import {
  CLOSE_PANEL, CLOSE_SIDEBAR, FOCUS_RESTORED, OPEN_PANEL, SET_SIDEBAR_WIDTH,
} from '../actions/types';
import { panelGroup as panelGroupType } from '../constants';

function createPanelGroup(id, config) {
  return {
    id,
    config,
    panels: [],
    offset: 0,
    nextPanelId: 0,
    userInitiatedUpdate: true,
  };
}

const initialState = {
  isOpen: false,
  lastPanelClosed: null,
  panelGroups: [
    createPanelGroup(panelGroupType.connections, {
      panelLimit: 3,
      pinFirstPanel: true,
    }),
    createPanelGroup(panelGroupType.enhancements, {
      panelLimit: 3,
    }),
  ],
  updatedPosition: 492,
};

function createNewPanel(id, { group, type, options }) {
  const {
    index = 0,
    launchProps,
    openerId,
  } = options || {};

  return {
    id,
    index,
    group,
    type,
    launchProps,
    openerId,
  };
}

function calculateOffset(totalPanels, panelLimit) {
  return totalPanels < panelLimit ? 0 : totalPanels - panelLimit;
}

function applyOpenerId(panels, index, openerId) {
  const previousPanel = panels[index - 1];
  if (previousPanel) {
    previousPanel.openerId = openerId;
  }
}

function panelGroup(state, action) {
  switch (action.type) {
    case OPEN_PANEL: {
      const { userInitiatedUpdate = true, openerId } = action.payload.options || {};
      const panel = createNewPanel(state.nextPanelId, action.payload);
      applyOpenerId(state.panels, panel.index, openerId);

      const panels = [...state.panels.slice(0, panel.index), panel];
      const offset = calculateOffset(panels.length, state.config.panelLimit);

      return {
        ...state,
        panels,
        nextPanelId: state.nextPanelId + 1,
        offset,
        userInitiatedUpdate,
      };
    }
    case CLOSE_PANEL: {
      const { index } = action.payload.panel;
      applyOpenerId(state.panels, index);

      const panels = state.panels.slice(0, index);
      const offset = calculateOffset(panels.length, state.config.panelLimit);

      return {
        ...state,
        panels,
        offset,
      };
    }
    default:
      return state;
  }
}

export default function sidebar(state = initialState, action = {}) {
  switch (action.type) {
    case CLOSE_SIDEBAR:
      return {
        ...state,
        isOpen: false,
        panelGroups: [...state.panelGroups.map(group => ({ ...group, panels: [] }))],
        lastPanelClosed: null,
      };
    case CLOSE_PANEL:
    case OPEN_PANEL: {
      const { panelGroups: prevPanelGroups } = state;
      const { group } = action.payload;
      const index = prevPanelGroups.findIndex(({ id }) => id === group);

      const panelGroups = [
        ...prevPanelGroups.slice(0, index),
        panelGroup(prevPanelGroups[index], action),
        ...prevPanelGroups.slice(index + 1),
      ];

      const isOpen = panelGroups.some(({ panels }) => panels.length > 0);
      const lastPanelClosed = action.type === CLOSE_PANEL
        ? action.payload.panel
        : state.lastPanelClosed;

      return {
        ...state,
        isOpen,
        panelGroups,
        lastPanelClosed,
      };
    }
    case FOCUS_RESTORED: {
      return {
        ...state,
        lastPanelClosed: null,
      };
    }
    case SET_SIDEBAR_WIDTH: {
      return {
        ...state,
        updatedPosition: action.payload.updatedPosition,
      };
    }
    default:
      return state;
  }
}
